






























































import { Vue, Component } from 'vue-property-decorator';
import { ITooltip } from '@/components/Globals/Form/form.t';
import CustomButton from '@/components/Globals/CustomButton.vue';
import CustomContainer from '@/components/Globals/CustomContainer.vue';
import CustomModal from '@/components/Modals/wrapper/modalWrapper.vue';
import CustomTooltip from '@/components/Globals/CustomTooltip.vue';
import ModalHeader from '@/components/molecule.modal.header.vue';
import personalizationMainView from '@/components/molecule.embroidery.mainView.vue';
import personalizationConfirmView from '@/components/molecule.embroidery.confirmView.vue';

import embroidery from '@/mixins/Embroidery';

@Component({
  components: {
    CustomButton,
    CustomContainer,
    CustomModal,
    ModalHeader,
    personalizationConfirmView,
    personalizationMainView,
    CustomTooltip
  },
  mixins: [embroidery],
})
export default class Embroidery extends Vue {
  [x: string]: any;

  ctaPrimaryTooltip: ITooltip | null = null;
  isBackButtonVisible: boolean = false;
  isCtaPrimaryBlocked: boolean = false;
  isCtaSecondaryButtonVisible: boolean = true;

  setBackButtonVisible(value: boolean) {
    this.isBackButtonVisible = value;
  }

  beforeOpenModal() {
    this.isCtaSecondaryButtonVisible = this.$store
      .getters['personalization/isPersonalizationInComponentRecipe']();
  }

  blockCtaPrimaryButton(value: boolean) {
    this.isCtaPrimaryBlocked = value;
  }

  closeAction() {
    this.$modal.hide('embroideryModal');

    this.isBackButtonVisible = false;
  }

  removePersonalization() {
    const componentName = this.$store.getters['personalization/getPersonalizationComponentName'];

    this.cleanPreviousEmbroidery(this.recipe_v2.components[componentName].personalization);
    this.$personalization.removePersonalization();
    this.closeAction();
  }
}
